import { router } from 'expo-router';
import { FlatList, StyleSheet, View } from 'react-native';

import { useGetTrendings } from '@/api/hooks/trendingsHooks';
import DotsLoader from '@/components/DotsLoader';
import ListEmptyComponent from '@/components/ListEmptyComponent';
import NextPageFetchingIndicator from '@/components/NextPageFetchingIndicator';
import TrendingCard from '@/components/trending/TrendingCard';
import { useAuth } from '@/contexts/authContext';
import useGetLocation from '@/hooks/useGetLocation';
import { i18n } from '@/utils/i18n';
import PlatformContainer from '@/components/web/PlatformContainer';
import { safeJsonParseArray } from '@/utils/firebaseImage';

const Trending = () => {
  const location = useGetLocation();

  const { state } = useAuth();

  const locationParsed =
    location?.latitude && location.longitude ? `${location.latitude},${location.latitude}` : state.user?.user?.location;

  const { data, isLoading, isFetchingNextPage, isRefetching, refetch, hasNextPage, isFetching, fetchNextPage } =
    useGetTrendings({
      limit: 5,
      location: locationParsed
    });

  const trendingPosts = data?.pages.flatMap((page) => page.results);

  //Locales
  const empty_list = i18n.t('engage.empty_trending');

  return (
    <PlatformContainer contentCustomClassnames="max-w-[1440px]">
      <View style={style.container}>
        {isLoading ? (
          <DotsLoader />
        ) : (
          <FlatList
            style={style.trendingList}
            showsVerticalScrollIndicator={false}
            data={trendingPosts}
            keyExtractor={(item) => item.id}
            contentContainerStyle={style.listContentContainer}
            onEndReachedThreshold={0.5}
            onEndReached={(_) => {
              hasNextPage && !isFetching && fetchNextPage();
            }}
            onRefresh={refetch}
            refreshing={isRefetching}
            renderItem={({ item }) => (
              <TrendingCard
                trendingTitle={item.title}
                trendingDate={item.eventDate}
                trendingImage={safeJsonParseArray(item.thumbnail)?.at(0) ?? ''}
                onCardPress={() => {
                  router.navigate({
                    pathname: '/trendingDetail/[trendingId]',
                    params: {
                      trendingId: item.id,
                      trendingJson: JSON.stringify(item)
                    }
                  });
                }}
              />
            )}
            ListEmptyComponent={<ListEmptyComponent label={empty_list} />}
            ListFooterComponent={isFetchingNextPage ? <NextPageFetchingIndicator /> : null}
          />
        )}
      </View>
    </PlatformContainer>
  );
};

export default Trending;

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },

  trendingList: {
    width: '100%'
  },

  listContentContainer: {
    paddingHorizontal: 18,
    rowGap: 20
  }
});
